import type { EventBookableItem } from '../../../../PublicUserProfile.types'

const getEventBookableItemLink = (event: EventBookableItem) => {
  return `/activity/${event.id}`
}

export default getEventBookableItemLink
